module.exports = __webpack_public_path__ + "img/to.94c0a0bf.svg";